// extracted by mini-css-extract-plugin
module.exports = {"paginationContainer":"paginationContainer--OtdJ5","top":"top--vsJqL"};